import styled, { css } from 'styled-components';
import { Row, media } from '@simplywallst/ui-core';
import { hexToRgbA } from '@/utilities/colors';

export const DesktopTopbarWrapper = styled(Row)`
  ${({ theme }) => theme.typography.small}
  color: white;
  height: ${({ theme }) => theme.desktopTopbarHeight}px;
  background: ${({ theme }) => theme.color.charcoal};
  min-height: ${({ theme }) => theme.desktopTopbarHeight}px;
  border-bottom: 1px solid ${({ theme }) => hexToRgbA(theme.color.white, 0.1)};

  body[data-theme] & {
    color: var(---s-nav-text-color);
    background: var(--s-nav-bg-color);
    border-bottom: 1px solid var(--s-nav-border-color);
  }
`;

interface Props {
  wide?: boolean;
}
export const DesktopTopbarBound = styled('div')<Props>`
  position: relative;
  width: 100%;
  transition: 0.6s all cubic-bezier(0.83, 0, 0.17, 1);
  ${(props) => {
    if (props.wide) {
      return css`
        @media (min-width: 1582px) {
          max-width: 1582px;
        }
        @media (min-width: 1440px) and (max-width: 1582px) {
          max-width: 1375px;
        }
        @media (max-width: 1439px) {
          max-width: ${props.theme.xlMin};
        }
      `;
    }
    return `
      max-width: ${props.theme.xlMin};
    `;
  }}
`;

type CanGoBack = {
  canGoBack: boolean;
};

export const MainNavigation = styled('div')<CanGoBack>`
  display: flex;
  padding-left: ${({ canGoBack }) => (canGoBack ? 235 : 215)}px;
  ${media.lgDown`
		padding-left: ${({ canGoBack }) => (canGoBack ? 90 : 70)}px;
	`};
`;

export const SWSLogoWrapper = styled('div')<CanGoBack>`
  position: absolute;
  top: 9px;
  left: ${({ theme, canGoBack }) =>
    canGoBack ? theme.x7spacePx : theme.x3spacePx}px;
  overflow-x: hidden;
  padding-top: 1px;
  ${media.lgDown`
		width: 30px;
	`} svg {
    width: 160px;
    ${media.lgDown`
			margin-left: -66px;
		`};
  }
`;

export const BackButton = styled('div')`
  position: absolute;
  left: 0;
  top: 12px;
  border-right: 1px solid ${({ theme }) => theme.color.darkerGray};
  > button {
    position: relative;
    padding: 0 12px;
    width: ${({ theme }) => theme.x5spacePx}px;
    height: ${({ theme }) => theme.x5spacePx}px;
    > svg {
      position: absolute;
      left: ${({ theme }) => theme.x1spacePx}px;
      top: ${({ theme }) => theme.x1spacePx}px;
      width: ${({ theme }) => theme.x3spacePx}px;
      height: ${({ theme }) => theme.x3spacePx}px;
      > * {
        fill: ${({ theme }) => theme.color.white};
      }
    }
  }
`;

export const SearchWrapper = styled.div`
  width: 100%;
  min-width: 100px;
  position: relative;
  display: inline-block;
  padding-top: 10px;
  ${media.mdDown`
		width: 30px !important;
	`};
`;

export const SearchField = styled.div`
  position: absolute;
  top: 8px;
  left: 40px;
  width: 220px;
`;
